import script from "./AccountHubPlatform.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountHubPlatform.vue?vue&type=script&setup=true&lang=js"

import "./AccountHubPlatform.vue?vue&type=style&index=0&id=58f72890&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f72890"]])

export default __exports__